<script setup>
import { ref, watch } from "vue";
import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/outline";
import TextInput from "@/Components/TextInput.vue";

defineOptions({ inheritAttrs: false });

const props = defineProps({
    modelValue: String,
});

defineEmits(["update:modelValue"]);

const input = ref(null);
const visible = ref(false);

watch(
    () => props.modelValue,
    (value) => {
        if (!value) {
            visible.value = false;
        }
    },
);

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <div class="relative" :class="$attrs.class">
        <TextInput
            v-bind="{ ...$attrs, class: undefined }"
            ref="input"
            :model-value="modelValue"
            :type="visible ? 'text' : 'password'"
            class="block w-full pr-12"
            @update:model-value="$emit('update:modelValue', $event)"
        />
        <button
            type="button"
            class="absolute inset-y-0 right-0 flex w-11 items-center justify-center rounded-r-md text-gray-500 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-theme-primary"
            :aria-label="visible ? __('Hide password') : __('Show password')"
            :aria-controls="$attrs.id"
            :title="visible ? __('Hide password') : __('Show password')"
            @click="visible = !visible"
        >
            <EyeSlashIcon v-if="visible" class="h-5 w-5" aria-hidden="true" />
            <EyeIcon v-else class="h-5 w-5" aria-hidden="true" />
        </button>
    </div>
</template>
